import { Badge } from 'components/Badge';
import { useGetAreaBlockinfo } from 'pages/documents_v2/hooks/useGetAreaBlockinfo';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export function AreaEditsIcon({ area }) {
    const { t } = useTranslation();
    const { documentId } = useParams();
    const { blockinfo } = useGetAreaBlockinfo(area.id, area.sectionId, parseInt(documentId));

    if (!blockinfo) {
        return null;
    }

    const { edits, unprocessedEdits } = blockinfo;
    const hasEdits = edits > 0 && unprocessedEdits > 0;

    if (edits === 0) {
        return null;
    }

    return (
        <Badge
            className="cursor-help font-weight-bolder"
            variant={hasEdits ? 'warning' : 'success'}
            tooltip={t('documents:document.navbar.main.tooltips.articleEdits')}
        >
            {edits - unprocessedEdits} / {edits}
        </Badge>
    );
}
